import { File, FileImage, FileSpreadsheet, FileText } from "lucide-react";

export function formatFileSize(bytes: number | null): string {
  if (bytes === null || bytes === 0) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function FileIcon({ mimeType }: { mimeType: string | null }) {
  if (mimeType?.startsWith("image/")) {
    return <FileImage className="h-4 w-4 shrink-0 text-blue-500" />;
  }
  if (mimeType === "application/pdf" || mimeType?.includes("document")) {
    return <FileText className="h-4 w-4 shrink-0 text-red-500" />;
  }
  if (
    mimeType?.includes("spreadsheet") ||
    mimeType?.includes("csv") ||
    mimeType?.includes("excel")
  ) {
    return <FileSpreadsheet className="h-4 w-4 shrink-0 text-green-500" />;
  }
  return <File className="h-4 w-4 shrink-0 text-muted-foreground" />;
}
